import { apiService } from './apiService';

export const shareTargetService = {
  async getTargets(includeInactive = false) {
    return apiService.get(`/share-targets${includeInactive ? '?includeInactive=true' : ''}`);
  },

  async createTarget(data: any) {
    return apiService.post('/share-targets', data);
  },

  async updateTarget(id: string | number, data: any) {
    return apiService.put(`/share-targets/${id}`, data);
  },

  async deleteTarget(id: string | number) {
    return apiService.delete(`/share-targets/${id}`);
  },

  async queueBidRequestShares(bidRequestId: string | number, shareText: string) {
    return apiService.post('/share-targets/queue', { bidRequestId, shareText });
  },
};
